import React, { useEffect, useState } from 'react';
import 'date-fns';
import { makeStyles } from '@material-ui/core/styles';
// core components
import {
  upload,
  getSupercategoryDetails
} from '../../store/actions/vendor/Vendor';
import InputLabel from '@material-ui/core/InputLabel';
import { Table, Button } from 'reactstrap';
import { connect } from 'react-redux';
import DateFnsUtils from '@date-io/date-fns';
import Grid from '@material-ui/core/Grid';
import EventIcon from '@material-ui/icons/Event';
import PasswordIcon from '@material-ui/icons/Security'
import axios from 'axios';

import AttachMoneyIcon from '@material-ui/icons/AttachMoney';
import {
  MuiPickersUtilsProvider,
  KeyboardTimePicker
} from '@material-ui/pickers';
import Store from '@material-ui/icons/Store';
import Phone from '@material-ui/icons/Phone';
import TouchApp from '@material-ui/icons/TouchApp';
import Map from '@material-ui/icons/Map';
import MenuItem from '@material-ui/core/MenuItem';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import {
  getCategory as getCategoryList,
  getRestaurantType,
  getVendorDetails,
  updateVendor
} from '../../store/actions/admin/Admin';
import NearMe from '@material-ui/icons/NearMe';
import PersonPinCircle from '@material-ui/icons/PersonPinCircle';
import LocationOn from '@material-ui/icons/LocationOn';
import { addVendor } from '../../store/actions/admin/Admin';
import CardHeader from '../../components/Card/CardHeader.js';
import CardBody from '../../components/Card/CardBody.js';
import CardFooter from '../../components/Card/CardFooter.js';
import GridItem from '../../components/Grid/GridItem.js';
import GridContainer from '../../components/Grid/GridContainer.js';
import CustomInputWithIcons from '../../components/CustomInput/CustomInputWithIcons.js';
import CustomInput from '../../components/CustomInput/CustomInput.js';
import { Checkbox, FormControlLabel } from "@material-ui/core";

import Autocomplete from 'react-google-autocomplete';
import { Flag, MailOutline } from '@material-ui/icons';
import { Input } from '@material-ui/core';
import SelectCurrency from '../../components/Flight/SelectCurrency'

const styles = {
  root: {
    width: 200,
    '& .MuiOutlinedInput-input': {
      color: 'green'
    },
    '& .MuiInputLabel-root': {
      color: 'green'
    },
    '& .MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline': {
      borderColor: 'green'
    },
    '&:hover .MuiOutlinedInput-input': {
      color: 'red'
    },
    '&:hover .MuiInputLabel-root': {
      color: 'red'
    },
    '&:hover .MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline': {
      borderColor: 'red'
    },
    '& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-input': {
      color: 'purple'
    },
    '& .MuiInputLabel-root.Mui-focused': {
      color: 'purple'
    },
    '& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline': {
      borderColor: 'purple'
    }
  },
  typo: {
    paddingLeft: '25%',
    marginBottom: '40px',
    position: 'relative'
  },
  note: {
    fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
    bottom: '10px',
    color: '#c0c1c2',
    display: 'block',
    fontWeight: '400',
    fontSize: '13px',
    lineHeight: '13px',
    left: '0',
    marginLeft: '20px',
    position: 'absolute',
    width: '260px'
  },
  cardCategoryWhite: {
    color: 'rgba(255,255,255,.62)',
    margin: '0',
    fontSize: '14px',
    marginTop: '0',
    marginBottom: '0'
  },
  cardTitleWhite: {
    color: '#FFFFFF',
    marginTop: '0px',
    minHeight: 'auto',
    fontWeight: '300',
    fontFamily: "'Roboto', 'Helvetica', 'Arial', sans-serif",
    marginBottom: '3px',
    textDecoration: 'none'
  },
  chips: {
    display: 'flex',
    flexWrap: 'wrap'
  },
  chip: {
    margin: 2
  },
  noLabel: {
    marginTop: 0,
    minWidth: 120,
    maxWidth: 300,
    paddingBottom: '10px',
    margin: '27px 0 0 0',
    position: 'relative',
    verticalAlign: 'unset'
  }
};

const useStyles = makeStyles(styles);

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250
    }
  }
};
// function getStyles(name, personName, theme) {
//   return {
//     fontWeight: personName.indexOf(name) === -1 ? theme.typography.fontWeightRegular : theme.typography.fontWeightMedium,
//   };
// }

const VendorDetail = (props) => {
  const classes = useStyles();
  const [isEdit, updateIsEdit] = useState(false);
  const [imageUploadMessage, updateImageUploadMessage] = useState('');
  const [vendor, updateVendor] = useState({
    name: '',
    emailId: '',
    phone_number: '',
    country_code: '',
    logo: '',
    eventTag: '',
    currency:'', 
    password:'',
    address: {
      building_number: '',
      street: '',
      city: '',
      state: '',
      country: '',
      pincode: '',
      latitude: '',
      longitude: ''
    },
    timing: {
      monday: {
        openTime: new Date('2021-08-18T08:00:00'),
        closeTime: new Date('2014-08-18T20:00:00'),
        isOpen: true
      },
      tuesday: {
        openTime: new Date('2021-08-18T08:00:00'),
        closeTime: new Date('2014-08-18T23:00:00'),
        isOpen: true
      },
      wednesday: {
        openTime: new Date('2021-08-18T08:00:00'),
        closeTime: new Date('2014-08-18T23:00:00'),
        isOpen: true
      },
      thrusday: {
        openTime: new Date('2021-08-18T08:00:00'),
        closeTime: new Date('2014-08-18T23:00:00'),
        isOpen: true
      },
      friday: {
        openTime: new Date('2021-08-18T08:00:00'),
        closeTime: new Date('2014-08-18T23:00:00'),
        isOpen: true
      },
      saturday: {
        openTime: new Date('2021-08-18T08:00:00'),
        closeTime: new Date('2014-08-18T23:00:00'),
        isOpen: true
      },
      sunday: {
        openTime: new Date('2021-08-18T09:00:00'),
        closeTime: new Date('2014-08-18T23:00:00'),
        isOpen: true
      }
    },
    active: false,
    superCategory: []
  });
  // const [isrestaurantType, updaterestaurantType] = useState(
  //   props.superCategoryDetails && props.superCategoryDetails.isResturant
  // );
  useEffect(() => {
    props.getCategoryList();
    props.getRestaurantType();

    const { vendorId } = props?.match?.params;
    if (vendorId) {
      updateIsEdit(!!vendorId);
      props.getVendorDetails(vendorId);
    }
  }, []);

  useEffect(() => {
    if (props?.vendorDetails && isEdit) {
      getDetails();
    }
  }, [props?.vendorDetails]);

  const getDetails = () => {
    updateVendor({
      vendorId: props.vendorDetails.id,
      name: props.vendorDetails.name,
      emailId: props.vendorDetails.emailId,
      phone_number: props.vendorDetails.phone_number,
      country_code: props.vendorDetails.country_code,
      logo: props.vendorDetails.logo,
      eventTag: props.vendorDetails.eventTag,
      currency:props.vendorDetails.currency,
      authPassword:props.vendorDetails.authPassword,
      address: {
        building_number: props.vendorDetails.address.building_number,
        street: props.vendorDetails.address.street,
        city: props.vendorDetails.address.city,
        state: props.vendorDetails.address.state,
        country: props.vendorDetails.address.country,
        pincode: props.vendorDetails.address.pincode,
        latitude: props.vendorDetails.address.latitude,
        longitude: props.vendorDetails.address.longitude
      },
      active: props.vendorDetails.active,
      timing: {
        monday: {
          openTime: props.vendorDetails.timing.monday.openTime,
          closeTime: props.vendorDetails.timing.monday.closeTime,
          isOpen: props.vendorDetails.timing.monday.isOpen
        },
        tuesday: {
          openTime: props.vendorDetails.timing.tuesday.openTime,
          closeTime: props.vendorDetails.timing.tuesday.closeTime,
          isOpen: props.vendorDetails.timing.tuesday.isOpen
        },
        wednesday: {
          openTime: props.vendorDetails.timing.wednesday.openTime,
          closeTime: props.vendorDetails.timing.wednesday.closeTime,
          isOpen: props.vendorDetails.timing.wednesday.isOpen
        },
        thrusday: {
          openTime: props.vendorDetails.timing.thrusday.openTime,
          closeTime: props.vendorDetails.timing.thrusday.closeTime,
          isOpen: props.vendorDetails.timing.thrusday.isOpen
        },
        friday: {
          openTime: props.vendorDetails.timing.friday.openTime,
          closeTime: props.vendorDetails.timing.friday.closeTime,
          isOpen: props.vendorDetails.timing.friday.isOpen
        },
        saturday: {
          openTime: props.vendorDetails.timing.saturday.openTime,
          closeTime: props.vendorDetails.timing.saturday.closeTime,
          isOpen: props.vendorDetails.timing.saturday.isOpen
        },
        sunday: {
          openTime: props.vendorDetails.timing.sunday.openTime,
          closeTime: props.vendorDetails.timing.sunday.closeTime,
          isOpen: props.vendorDetails.timing.sunday.isOpen
        }
      },
      superCategory: props.vendorDetails.superCategory
    });
  };
  

  const onChange = (event) => {
    let tempVendor = { ...vendor };
    tempVendor[event.target.name] = event.target.value;
    updateVendor(tempVendor);
  };

  const getCity = (addressArray) => {
    let city = '';
    for (let i = 0; i < addressArray.length; i++) {
      if (addressArray[i].types[0] && 'locality' === addressArray[i].types[0]) {
        city = addressArray[i].long_name;
        return city;
      }
    }
  };

  const getArea = (addressArray) => {
    let area = '';
    for (let i = 0; i < addressArray.length; i++) {
      if (addressArray[i].types[0]) {
        for (let j = 0; j < addressArray[i].types.length; j++) {
          if ('route' === addressArray[i].types[j]) {
            area = addressArray[i].long_name;
            return area;
          }
        }
      }
    }
  };

  const getState = (addressArray) => {
    let state = '';
    for (let i = 0; i < addressArray.length; i++) {
      for (let i = 0; i < addressArray.length; i++) {
        if (
          addressArray[i].types[0] &&
          'administrative_area_level_1' === addressArray[i].types[0]
        ) {
          state = addressArray[i].long_name;
          return state;
        }
      }
    }
  };

  const getCountry = (addressArray) => {
    let country = '';
    for (let i = 0; i < addressArray.length; i++) {
      for (let i = 0; i < addressArray.length; i++) {
        if (
          addressArray[i].types[0] &&
          'country' === addressArray[i].types[0]
        ) {
          country = addressArray[i].long_name;
          return country;
        }
      }
    }
  };

  const getPincode = (addressArray) => {
    let pincode = '';
    for (let i = 0; i < addressArray.length; i++) {
      for (let i = 0; i < addressArray.length; i++) {
        if (
          addressArray[i].types[0] &&
          'postal_code' === addressArray[i].types[0]
        ) {
          pincode = addressArray[i].long_name;
          return pincode;
        }
      }
    }
  };

  const onChangeAdress = (place) => {
    const address = place.formatted_address,
      addressArray = place.address_components,
      city = getCity(addressArray),
      area = getArea(addressArray),
      state = getState(addressArray),
      country = getCountry(addressArray),
      pincode = getPincode(addressArray),
      latValue = place.geometry.location.lat().toString(),
      lngValue = place.geometry.location.lng().toString();

    const vendorAddress = {
      city,
      state,
      street: area,
      country,
      pincode,
      building_number: address,
      latitude: latValue,
      longitude: lngValue
    };
    const tempVendor = {
      ...vendor,
      address: {
        ...vendor.address,
        ...vendorAddress
      }
    };
    updateVendor(tempVendor);
  };

  const onUpload = (event) => {
    updateImageUploadMessage('Uploading the file, please wait...');

    let data = new FormData();
    data.append('files', event.target.files[0]);
    props
      .upload(data)
      .then((response) => {
        if (response.status === 201) {
          updateImageUploadMessage('File uploaded successfully.');
          const tempVendor = { ...vendor };
          tempVendor.logo = `${response.data.uploads[0].path}`;
          updateVendor(tempVendor);
        } else {
          updateImageUploadMessage('Please, try Again');
        }
      })
      .catch((error) => {
        updateImageUploadMessage(
          'An error occurred while executing the query. Please try Again'
        );
      })
      .then(() => {
        console.log('Image uploaded');
      });
  };

  const onChangeTiming = (date, day, time) => {
    const tempVendor = { ...vendor };
    const vendorTiming = { ...tempVendor.timing };
    vendorTiming[day][time] = date;
    tempVendor.timing = vendorTiming;
    updateVendor(tempVendor);
  };

  const onChangeActive = () => {
    var tempVendor = { ...vendor };
    tempVendor.active = !tempVendor.active;
    updateVendor(tempVendor);
  };

  const onChangeSuperCategory = (event) => {
    let tempVendor = { ...vendor };
    tempVendor[event.target.name] = [event.target.value];
    props.getSupercategoryDetails(event.target.value);
    if (event.target.name === 'superCategory') {
      tempVendor.superCategory = [event.target.value];
    }
    updateVendor(tempVendor);
  };

  const onChangeRestaurantType = (event) => {
    let tempVendor = { ...vendor };
    tempVendor[event.target.name] = [event.target.value];

    if (event.target.name === 'restaurantType') {
      tempVendor.restaurantType = [event.target.value];
    }
    updateVendor(tempVendor);
  };

  const onSubmit = (event) => {
    event.preventDefault();
    if (props.match.params.vendorId) {
      props.updateVendor(vendor).then((data) => {
        if (data) {
          props.history.push('/admin/vendors');
        }
      });
    } else {
      props.addVendor(vendor).then((data) => {
        if (data) {
          props.history.push('/admin/vendors');
        }
      });
    }
  };

  const handleCurrencyChange=(curr)=>{
    onChange({target:{name:"currency",value:curr}});
  }
  return (
    <>
      <CardHeader color="primary">
        <h4 className={classes.cardTitleWhite}>Add a vendor</h4>
        <p className={classes.cardCategoryWhite}>
          When choosing icon, PNG images would be better over JPG or imap
        </p>
      </CardHeader>
      <br />
      <CardBody>
        <p
          style={{
            textAlign: 'left',
            paddingLeft: '9px',
            fontSize: '15px',
            fontWeight: 'bold',
            paddingRight: '9px',
            paddingTop: '9px',
            color: '#A641B9',
            borderRadius: '6px',
            paddingBottom: '9px',
            width: '152px',
            backgroundColor: '#A641B920'
          }}
        >
          Basic informations
        </p>
        <GridContainer>
          <GridItem xs={6} sm={6} md={3}>
            <div className={classes.formControl}>
              <Grid container spacing={1} alignItems="flex-end">
                <Grid item>
                  <Store style={{ color: '#00000090' }} />
                </Grid>
                <Grid item>
                  <CustomInputWithIcons
                    labelText="Vendor Name"
                    value={vendor.name}
                    onChange={onChange}
                    name="name"
                    id="name"
                    formControlProps={{
                      fullWidth: true
                    }}
                  />
                </Grid>
              </Grid>
            </div>
          </GridItem>
          <GridItem xs={6} sm={6} md={3}>
            <div className={classes.formControl}>
              <Grid container spacing={1} alignItems="flex-end">
                <Grid item>
                  <MailOutline style={{ color: '#00000090' }} />
                </Grid>
                <Grid item>
                  <CustomInputWithIcons
                    labelText="Vendor Email"
                    value={vendor.emailId}
                    onChange={onChange}
                    name="emailId"
                    id="emailId"
                    formControlProps={{
                      fullWidth: true
                    }}
                  />
                </Grid>
              </Grid>
            </div>
          </GridItem>

          <GridItem xs={6} sm={6} md={4}>
            <div className={classes.formControl}>
              <Grid
                container
                spacing={1}
                alignItems="flex-end"
                style={{ marginTop: '-28px' }}
              >
                <Grid item>
                  <CustomInput
                    labelText="Vendor Logo"
                    id="logo"
                    type="file"
                    name="logo"
                    accept="image/png, image/jpeg, image/jpg"
                    onChange={onUpload}
                    formControlProps={{
                      fullWidth: true
                    }}
                  />
                  <br />
                  <p style={{ color: '#000' }}>{imageUploadMessage}</p>
                </Grid>
              </Grid>
            </div>
          </GridItem>
          <GridItem xs={6} sm={6} md={3}>
            <div className={classes.formControl}>
              <Grid container spacing={1} alignItems="flex-end">
                <Grid item>
                  <Flag style={{ color: '#00000090' }} />
                </Grid>
                <Grid item>
                  <CustomInputWithIcons
                    labelText="Regional Code"
                    value={vendor.country_code}
                    onChange={onChange}
                    name="country_code"
                    id="country_code"
                    formControlProps={{
                      fullWidth: true
                    }}
                  />
                </Grid>
              </Grid>
            </div>
          </GridItem>
          <GridItem xs={6} sm={6} md={3}>
            <div className={classes.formControl}>
              <Grid container spacing={1} alignItems="flex-end">
                <Grid item>
                  <Phone style={{ color: '#00000090' }} />
                </Grid>
                <Grid item>
                  <CustomInputWithIcons
                    labelText="Vendor Phone Number"
                    value={vendor.phone_number}
                    onChange={onChange}
                    name="phone_number"
                    id="phone_number"
                    formControlProps={{
                      fullWidth: true
                    }}
                  />
                </Grid>
              </Grid>
            </div>
          </GridItem>
          <GridItem xs={6} sm={6} md={3}>
            <div className={classes.formControl}>
              <Grid container spacing={1} alignItems="flex-end">
                <Grid item>
                  <EventIcon style={{ color: '#00000090' }} />
                </Grid>
                <Grid item>
                  <CustomInputWithIcons
                    labelText="Event Tag"
                    value={vendor.eventTag}
                    onChange={onChange}
                    name="eventTag"
                    id="eventTag"
                    formControlProps={{
                      fullWidth: true
                    }}
                  />
                </Grid>
              </Grid>
            </div>
          </GridItem>
          <GridItem xs={6} sm={6} md={3}>
            <div className={classes.formControl} style={{textAlign:'left'}}>
              <Grid container spacing={1} >
                <div>
                  <AttachMoneyIcon style={{ color: '#00000090' }} />
            </div> 
                
                <Grid item  xs="12"> 
                <br/>
                <FormControl className={classes.formControl}>                  
                   <SelectCurrency theme="light"  disableUnderline={false} handleChange={handleCurrencyChange} value={vendor.currency}/>
                </FormControl>
                </Grid>
              </Grid>
            </div>
          </GridItem>
          <GridItem xs={6} sm={6} md={3}>
            <div className={classes.formControl}>
              <Grid container spacing={1} alignItems="flex-end">
                <Grid item>
                  <PasswordIcon style={{ color: '#00000090' }} />
                </Grid>
                <Grid item>
                  <CustomInputWithIcons
                    labelText="Password"
                    value={vendor.authPassword}
                    onChange={onChange}
                    name="authPassword"
                    id="authPassword"
                    type='password'
                    formControlProps={{
                      fullWidth: true
                    }}
                  />
                </Grid>
              </Grid>
            </div>
          </GridItem>
        </GridContainer>
        <br />
        <br />
        <p
          style={{
            textAlign: 'left',
            paddingLeft: '9px',
            fontSize: '15px',
            fontWeight: 'bold',
            paddingRight: '9px',
            paddingTop: '9px',
            color: '#A641B9',
            borderRadius: '6px',
            paddingBottom: '9px',
            width: '166px',
            backgroundColor: '#A641B920'
          }}
        >
          Address details
        </p>
        <GridContainer>
          <GridItem xs={6} sm={6} md={3}>
            <div className={classes.formControl}>
              <Grid container spacing={1} alignItems="flex-end">
                <Grid item>
                  <LocationOn style={{ color: '#00000090' }} />
                </Grid>
                <Grid item>
                  <Autocomplete
                    className="form-control"
                    onPlaceSelected={(place) => onChangeAdress(place)}
                    types={[]}
                    componentRestrictions={{ country: 'au' }}
                  />
                </Grid>
              </Grid>
            </div>
          </GridItem>
          <GridItem xs={6} sm={6} md={3}>
            <div className={classes.formControl}>
              <Grid container spacing={1} alignItems="flex-end">
                <Grid item>
                  <NearMe style={{ color: '#00000090' }} />
                </Grid>
                <Grid item>
                  <CustomInputWithIcons
                    labelText="Address street"
                    value={vendor?.address?.street}
                    onChange={onChangeAdress}
                    name="street"
                    id="street"
                    formControlProps={{
                      fullWidth: true
                    }}
                  />
                </Grid>
              </Grid>
            </div>
          </GridItem>
          <GridItem xs={6} sm={6} md={3}>
            <div className={classes.formControl}>
              <Grid container spacing={1} alignItems="flex-end">
                <Grid item>
                  <PersonPinCircle style={{ color: '#00000090' }} />
                </Grid>
                <Grid item>
                  <CustomInputWithIcons
                    labelText="City"
                    value={vendor?.address?.city}
                    onChange={onChangeAdress}
                    name="city"
                    id="city"
                    formControlProps={{
                      fullWidth: true
                    }}
                  />
                </Grid>
              </Grid>
            </div>
          </GridItem>
          <GridItem xs={6} sm={6} md={3}>
            <div className={classes.formControl}>
              <Grid container spacing={1} alignItems="flex-end">
                <Grid item>
                  <LocationOn style={{ color: '#00000090' }} />
                </Grid>
                <Grid item>
                  <CustomInputWithIcons
                    labelText="State"
                    value={vendor?.address?.state}
                    onChange={onChangeAdress}
                    name="state"
                    id="state"
                    formControlProps={{
                      fullWidth: true
                    }}
                  />
                </Grid>
              </Grid>
            </div>
          </GridItem>
          <GridItem xs={6} sm={6} md={3}>
            <div className={classes.formControl}>
              <Grid container spacing={1} alignItems="flex-end">
                <Grid item>
                  <Flag style={{ color: '#00000090' }} />
                </Grid>
                <Grid item>
                  <CustomInputWithIcons
                    labelText="Country"
                    value={vendor?.address?.country}
                    onChange={onChangeAdress}
                    name="country"
                    id="country"
                    formControlProps={{
                      fullWidth: true
                    }}
                  />
                </Grid>
              </Grid>
            </div>
          </GridItem>
          <GridItem xs={6} sm={6} md={3}>
            <div className={classes.formControl}>
              <Grid container spacing={1} alignItems="flex-end">
                <Grid item>
                  <TouchApp style={{ color: '#00000090' }} />
                </Grid>
                <Grid item>
                  <CustomInputWithIcons
                    labelText="Pincode"
                    value={vendor?.address?.pincode}
                    onChange={onChangeAdress}
                    name="pincode"
                    id="pincode"
                    formControlProps={{
                      fullWidth: true
                    }}
                  />
                </Grid>
              </Grid>
            </div>{' '}
          </GridItem>
          <GridItem xs={6} sm={6} md={3}>
            <div className={classes.formControl}>
              <Grid container spacing={1} alignItems="flex-end">
                <Grid item>
                  <Map style={{ color: '#00000090' }} />
                </Grid>
                <Grid item>
                  <CustomInputWithIcons
                    labelText="Latitude"
                    value={vendor?.address?.latitude}
                    onChange={onChangeAdress}
                    name="latitude"
                    id="latitude"
                    formControlProps={{
                      fullWidth: true
                    }}
                  />
                </Grid>
              </Grid>
            </div>
          </GridItem>
          <GridItem xs={6} sm={6} md={3}>
            <div className={classes.formControl}>
              <Grid container spacing={1} alignItems="flex-end">
                <Grid item>
                  <Map style={{ color: '#00000090' }} />
                </Grid>
                <Grid item>
                  <CustomInputWithIcons
                    labelText="Longitude"
                    value={vendor?.address?.longitude}
                    onChange={onChangeAdress}
                    name="longitude"
                    id="longitude"
                    formControlProps={{
                      fullWidth: true
                    }}
                  />
                </Grid>
              </Grid>
            </div>
          </GridItem>
        </GridContainer>
        <br /> <br />
        <p
          style={{
            textAlign: 'left',
            paddingLeft: '9px',
            fontSize: '15px',
            fontWeight: 'bold',
            paddingRight: '2px',
            paddingTop: '9px',
            color: '#A641B9',
            borderRadius: '6px',
            paddingBottom: '9px',
            width: '196px',
            backgroundColor: '#A641B920'
          }}
        >
          Schedule informations
        </p>
        <GridContainer>
          <GridItem xs={6} sm={6} md={3}>
            <div className={classes.formControl}>
              <MuiPickersUtilsProvider utils={DateFnsUtils}>
                <Grid container justify="space-around">
                  <Grid item>
                    <KeyboardTimePicker
                      margin="normal"
                      id="time-picker"
                      label="Monday openTime"
                      value={vendor?.timing?.monday?.openTime}
                      onChange={(date) =>
                        onChangeTiming(date, 'monday', 'openTime')
                      }
                      name="openTime"
                      KeyboardButtonProps={{
                        'aria-label': 'change time'
                      }}
                    />
                  </Grid>
                </Grid>
              </MuiPickersUtilsProvider>
            </div>
          </GridItem>
          <GridItem xs={6} sm={6} md={3}>
            <div className={classes.formControl}>
              <MuiPickersUtilsProvider utils={DateFnsUtils}>
                <Grid container justify="space-around">
                  <Grid item>
                    <KeyboardTimePicker
                      margin="normal"
                      id="time-picker"
                      label="Monday closeTime"
                      value={vendor.timing.monday.closeTime}
                      onChange={(date) =>
                        onChangeTiming(date, 'monday', 'closeTime')
                      }
                      name="closeTime"
                      KeyboardButtonProps={{
                        'aria-label': 'change time'
                      }}
                    />
                  </Grid>
                </Grid>
              </MuiPickersUtilsProvider>
            </div>
          </GridItem>
          <GridItem xs={6} sm={6} md={3}>
            <div className={classes.formControl}>
              <MuiPickersUtilsProvider utils={DateFnsUtils}>
                <Grid container justify="space-around">
                  <Grid item>
                    <KeyboardTimePicker
                      margin="normal"
                      id="time-picker"
                      label="Tuesday openTime"
                      value={vendor.timing.tuesday.openTime}
                      onChange={(date) =>
                        onChangeTiming(date, 'tuesday', 'openTime')
                      }
                      name="openTime"
                      KeyboardButtonProps={{
                        'aria-label': 'change time'
                      }}
                    />{' '}
                  </Grid>
                </Grid>
              </MuiPickersUtilsProvider>
            </div>
          </GridItem>
          <GridItem xs={6} sm={6} md={3}>
            <div className={classes.formControl}>
              <MuiPickersUtilsProvider utils={DateFnsUtils}>
                <Grid container justify="space-around">
                  <Grid item>
                    <KeyboardTimePicker
                      margin="normal"
                      id="time-picker"
                      label="Tuesday closeTime"
                      value={vendor.timing.tuesday.closeTime}
                      onChange={(date) =>
                        onChangeTiming(date, 'tuesday', 'closeTime')
                      }
                      name="closeTime"
                      KeyboardButtonProps={{
                        'aria-label': 'change time'
                      }}
                    />
                  </Grid>
                </Grid>
              </MuiPickersUtilsProvider>
            </div>
          </GridItem>
          <GridItem xs={6} sm={6} md={3}>
            <div className={classes.formControl}>
              <MuiPickersUtilsProvider utils={DateFnsUtils}>
                <Grid container justify="space-around">
                  <Grid item>
                    <KeyboardTimePicker
                      margin="normal"
                      id="time-picker"
                      label="Wednesday openTime"
                      value={vendor.timing.wednesday.openTime}
                      onChange={(date) =>
                        onChangeTiming(date, 'wednesday', 'openTime')
                      }
                      name="openTime"
                      KeyboardButtonProps={{
                        'aria-label': 'change time'
                      }}
                    />
                  </Grid>
                </Grid>
              </MuiPickersUtilsProvider>
            </div>
          </GridItem>
          <GridItem xs={6} sm={6} md={3}>
            <div className={classes.formControl}>
              <MuiPickersUtilsProvider utils={DateFnsUtils}>
                <Grid container justify="space-around">
                  <Grid item>
                    <KeyboardTimePicker
                      margin="normal"
                      id="time-picker"
                      label="Wednesday closeTime"
                      value={vendor.timing.wednesday.closeTime}
                      onChange={(date) =>
                        onChangeTiming(date, 'wednesday', 'closeTime')
                      }
                      name="closeTime"
                      KeyboardButtonProps={{
                        'aria-label': 'change time'
                      }}
                    />
                  </Grid>
                </Grid>
              </MuiPickersUtilsProvider>
            </div>
          </GridItem>
          <GridItem xs={6} sm={6} md={3}>
            <div className={classes.formControl}>
              <MuiPickersUtilsProvider utils={DateFnsUtils}>
                <Grid container justify="space-around">
                  <Grid item>
                    <KeyboardTimePicker
                      margin="normal"
                      id="time-picker"
                      label="Thrusday openTime"
                      value={vendor.timing.thrusday.openTime}
                      onChange={(date) =>
                        onChangeTiming(date, 'thrusday', 'openTime')
                      }
                      name="openTime"
                      KeyboardButtonProps={{
                        'aria-label': 'change time'
                      }}
                    />
                  </Grid>
                </Grid>
              </MuiPickersUtilsProvider>
            </div>
          </GridItem>
          <GridItem xs={6} sm={6} md={3}>
            <div className={classes.formControl}>
              <MuiPickersUtilsProvider utils={DateFnsUtils}>
                <Grid container justify="space-around">
                  <Grid item>
                    <KeyboardTimePicker
                      margin="normal"
                      id="time-picker"
                      label="Thrusday closeTime"
                      value={vendor.timing.thrusday.closeTime}
                      onChange={(date) =>
                        onChangeTiming(date, 'thrusday', 'closeTime')
                      }
                      name="closeTime"
                      KeyboardButtonProps={{
                        'aria-label': 'change time'
                      }}
                    />
                  </Grid>
                </Grid>
              </MuiPickersUtilsProvider>
            </div>
          </GridItem>
          <GridItem xs={6} sm={6} md={3}>
            <div className={classes.formControl}>
              <MuiPickersUtilsProvider utils={DateFnsUtils}>
                <Grid container justify="space-around">
                  <Grid item>
                    <KeyboardTimePicker
                      margin="normal"
                      id="time-picker"
                      label="Friday openTime"
                      value={vendor.timing.friday.openTime}
                      onChange={(date) =>
                        onChangeTiming(date, 'friday', 'openTime')
                      }
                      name="openTime"
                      KeyboardButtonProps={{
                        'aria-label': 'change time'
                      }}
                    />
                  </Grid>
                </Grid>
              </MuiPickersUtilsProvider>
            </div>
          </GridItem>
          <GridItem xs={6} sm={6} md={3}>
            <div className={classes.formControl}>
              <MuiPickersUtilsProvider utils={DateFnsUtils}>
                <Grid container justify="space-around">
                  <Grid item>
                    <KeyboardTimePicker
                      margin="normal"
                      id="time-picker"
                      label="Friday closeTime"
                      value={vendor.timing.friday.closeTime}
                      onChange={(date) =>
                        onChangeTiming(date, 'friday', 'closeTime')
                      }
                      name="closeTime"
                      KeyboardButtonProps={{
                        'aria-label': 'change time'
                      }}
                    />
                  </Grid>
                </Grid>
              </MuiPickersUtilsProvider>
            </div>
          </GridItem>
          <GridItem xs={6} sm={6} md={3}>
            <div className={classes.formControl}>
              <MuiPickersUtilsProvider utils={DateFnsUtils}>
                <Grid container justify="space-around">
                  <Grid item>
                    <KeyboardTimePicker
                      margin="normal"
                      id="time-picker"
                      label="Saturday openTime"
                      value={vendor.timing.saturday.openTime}
                      onChange={(date) =>
                        onChangeTiming(date, 'saturday', 'openTime')
                      }
                      name="openTime"
                      KeyboardButtonProps={{
                        'aria-label': 'change time'
                      }}
                    />
                  </Grid>
                </Grid>
              </MuiPickersUtilsProvider>
            </div>
          </GridItem>
          <GridItem xs={6} sm={6} md={3}>
            <div className={classes.formControl}>
              <MuiPickersUtilsProvider utils={DateFnsUtils}>
                <Grid container justify="space-around">
                  <Grid item>
                    <KeyboardTimePicker
                      margin="normal"
                      id="time-picker"
                      label="Saturday closeTime"
                      value={vendor.timing.saturday.closeTime}
                      onChange={(date) =>
                        onChangeTiming(date, 'saturday', 'closeTime')
                      }
                      name="closeTime"
                      KeyboardButtonProps={{
                        'aria-label': 'change time'
                      }}
                    />
                  </Grid>
                </Grid>
              </MuiPickersUtilsProvider>
            </div>
          </GridItem>
          <GridItem xs={6} sm={6} md={3}>
            <div className={classes.formControl}>
              <MuiPickersUtilsProvider utils={DateFnsUtils}>
                <Grid container justify="space-around">
                  <Grid item>
                    <KeyboardTimePicker
                      margin="normal"
                      id="time-picker"
                      label="Sunday openTime"
                      value={vendor.timing.sunday.openTime}
                      onChange={(date) =>
                        onChangeTiming(date, 'sunday', 'openTime')
                      }
                      name="openTime"
                      KeyboardButtonProps={{
                        'aria-label': 'change time'
                      }}
                    />
                  </Grid>
                </Grid>
              </MuiPickersUtilsProvider>
            </div>
          </GridItem>
          <GridItem xs={6} sm={6} md={3}>
            <div className={classes.formControl}>
              <MuiPickersUtilsProvider utils={DateFnsUtils}>
                <Grid container justify="space-around">
                  <Grid item>
                    <KeyboardTimePicker
                      margin="normal"
                      id="time-picker"
                      label="Sunday closeTime"
                      value={vendor.timing.sunday.closeTime}
                      onChange={(date) =>
                        onChangeTiming(date, 'sunday', 'closeTime')
                      }
                      name="closeTime"
                      KeyboardButtonProps={{
                        'aria-label': 'change time'
                      }}
                    />
                  </Grid>
                </Grid>
              </MuiPickersUtilsProvider>
            </div>
          </GridItem>
        </GridContainer>
        <br />
        <p
          style={{
            textAlign: 'left',
            paddingLeft: '9px',
            fontSize: '15px',
            fontWeight: 'bold',
            paddingRight: '9px',
            paddingTop: '9px',
            color: '#A641B9',
            borderRadius: '6px',
            paddingBottom: '9px',
            width: '152px',
            backgroundColor: '#A641B920'
          }}
        >
          Vendor Category
        </p>
        <GridContainer>
          <GridItem xs={6} sm={6} md={3}>
            <div className={classes.formControl}>
              <Grid container spacing={1} alignItems="flex-end">
                <Grid item></Grid>
                <Grid item>
                  <FormControl className={classes.formControl}>
                    <InputLabel id="demo-controlled-open-select-label">
                      SuperCategory
                    </InputLabel>
                    <Select
                      labelId="demo-controlled-open-select-label"
                      id="demo-controlled-open-select-label"
                      className={classes.root}
                      value={vendor.superCategory}
                      onChange={onChangeSuperCategory}
                      name="superCategory"
                      input={<Input />}
                      MenuProps={MenuProps}
                    >
                      {props.superCategories.map((type) => (
                        <MenuItem
                          key={type.id}
                          className={classes.noLabel}
                          value={type.id}
                        >
                          {type.name}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Grid>
              </Grid>
            </div>
          </GridItem>
          {props.superCategoryDetails &&
            props.superCategoryDetails.isResturant && (
              <GridItem xs={6} sm={6} md={3}>
                <div className={classes.formControl}>
                  <Grid container spacing={1} alignItems="flex-end">
                    <Grid item></Grid>
                    <Grid item>
                      <FormControl className={classes.formControl}>
                        <InputLabel id="demo-controlled-open-select-label">
                          restaurantType
                        </InputLabel>
                        <Select
                          labelId="demo-controlled-open-select-label"
                          id="demo-controlled-open-select-label"
                          className={classes.root}
                          value={vendor.restaurantType}
                          onChange={onChangeRestaurantType}
                          name="restaurantType"
                          input={<Input />}
                          MenuProps={MenuProps}
                        >
                          {props.restaurantType &&
                            props.restaurantType.map((type) => (
                              <MenuItem
                                key={type.id}
                                className={classes.noLabel}
                                value={type.id}
                              >
                                {type.name}
                              </MenuItem>
                            ))}
                        </Select>
                      </FormControl>
                    </Grid>
                  </Grid>
                </div>
              </GridItem>
              
            )}
            <GridItem xs={12} sm={12} md={3} style={{ marginTop: '10px' }}>
              <FormControlLabel
                control={
                  <Checkbox
                    checked={vendor.active}
                    onChange={onChangeActive}
                    name="active"
                  />
                }
                label="Active"
              />
            </GridItem>
        </GridContainer>
      </CardBody>
      <CardFooter>
        <Button
          type="submit"
          onClick={onSubmit}
          style={{
            color: '#fff',
            backgroundColor: '#9c27b0',
            boxShadow:
              '0 2px 2px 0 rgba(156, 39, 176, 0.14), 0 3px 1px -2px rgba(156, 39, 176, 0.2), 0 1px 5px 0 rgba(156, 39, 176, 0.12)'
          }}
        >
          {isEdit ? 'Update Vendor' : 'Add Vendor'}
        </Button>
      </CardFooter>
      <br /> <br />
      <Table hover>
        <thead>
          <tr>
            <th>#</th>
            <th>Name</th>
            <th>Logo</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <th>1</th>
            <td>{vendor.name}</td>
            <td>
              <img src={vendor.logo} style={{ height: '70px' }} alt="" />
            </td>
          </tr>
        </tbody>
      </Table>
    </>
  );
};

const mapStateWithProps = (state) => ({
  superCategories: state.admin.superCategories,
  vendorDetails: state.admin.vendorDetails,
  restaurantType: state.admin.restaurantType,
  superCategoryDetails: state.admin.superCategoryDetails
});

const mapDispatchWithProps = (dispatch) => {
  return {
    getCategoryList: () => dispatch(getCategoryList()),
    getVendorDetails: (vendorId) => dispatch(getVendorDetails(vendorId)),
    updateVendor: (vendor) => dispatch(updateVendor(vendor)),
    addVendor: (vendor) => dispatch(addVendor(vendor)),
    upload: (data) => dispatch(upload(data)),
    getRestaurantType: () => dispatch(getRestaurantType()),
    getSupercategoryDetails: (superCategoryId) =>
      dispatch(getSupercategoryDetails(superCategoryId))
  };
};

export default connect(mapStateWithProps, mapDispatchWithProps)(VendorDetail);
